// import React from 'react'

// export default function Dashboard() { 

//   return (
//     <div>Dashboard</div>
//   )
// }


import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import { Container, Row, Col } from 'react-bootstrap';
import "../pages/Admin/AdminDashboard.css";
import "../pages/Admin/Admin.css";
import 'boxicons/css/boxicons.min.css';
import TopBar from "../pages/Admin/TopBar";

const Dashboard = () => {
    const navigate = useNavigate();
    const logout = useLogout();
    const { auth } = useAuth();

    const signOut = async () => {
        await logout();
        navigate('/login');
    }

    return (

        <Container>
            {/* <div className="dashhead">
                <Row>
                    <Col><h5 className="dashhe">Dashboard</h5></Col>
                    <Col>
                    <div className="dashdiv">
                    <strong><i className="bx bxs-user icon dashicon"></i></strong> {auth?.name} / 
                    
                    <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link> 
                    </div>
                    </Col>
                </Row>
            </div> */}

            <section className="adminsec">

                <div className="center-image">

                    <img src="/images/newlogo.png" width="30%" className='' />
                </div>
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">Hai <span className="colorChange">{auth?.name}</span>!</h2>
                    <p className="dashwel2">Welcome to <span className="colorChange">{auth?.franchise_name}</span></p>
                </center>
                <br />

                <Row>
                    <Col md={3}>
                        <div className="adminst">
                            <Link to="/editor"><i className="bx bx-edit admicon"></i> Edit</Link>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="adminst">
                            <Link to="/admin"><strong><i className="bx bxs-user icon admicon"></i></strong> Admin </Link>
                        </div>
                    </Col>
                    <Col md={3}><div className="adminst">
                        <Link to="/lounge"><i className="bx bx-globe admicon"></i> Language</Link>
                    </div>
                    </Col>
                    <Col md={3}><div className="adminst">
                        <Link to="/linkpage"><i className="bx bx-link admicon"></i> Link </Link>
                    </div>
                    </Col>
                </Row>
                {/* <Row>
            <Col md={12}>
            <div className="flexGrow adminbut">
                <button onClick={signOut} className="adminsign">Sign Out</button>
            </div>
            </Col>
            </Row> */}





                {/* <Link to="/editor">Go to the Editor page</Link>
            <br />
            <Link to="/admin">Go to the Admin page</Link>
            <br />
            <Link to="/lounge">Go to the Lounge</Link>
            <br />
            <Link to="/linkpage">Go to the link page</Link> */}
                {/* <div className="flexGrow">
                <button onClick={signOut}>Sign Out</button>
            </div> */}


            </section>
            <TopBar />
        </Container>
    )
}

export default Dashboard
